<template>
	<div class="o-container o-container--thin registration-page">
		<change-password-form :submit="changePassword"></change-password-form>
	</div>
</template>

<script>
	import ChangePasswordForm from '../forms/ChangePasswordForm.vue';

	export default {
		components: {
			ChangePasswordForm
		},
		methods: {
			changePassword(userPasswords) {
				return this.$store.dispatch('user/CHANGE_PASSWORD', userPasswords).then(() => {
					this.$router.push({
						name: 'myAccount',
						params: {
							message: {
								type: 'success',
								value: 'Your new password has been successfully saved.'
							}
						}
					});
				});
			}
		}
	}
</script>
